<style lang="less" scoped>
.query-title-div {
  width: 110px !important;
}
.lang-width {
  width: 450px !important;
}
.margin-tb {
  height: 32px;
  margin-top: 4px;
}
.notice-main-title-div {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
}
.query-flex-btns-div{
  display: flex;
  justify-content: flex-end;
}
</style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">广告位配置</div>
      <div class="page-action-btns flex margin-tb-10">
        <div class="flex-grow-1"></div>
        <!-- <button
          class="common-bg-button"
          @click="
            () => {
              showMultiQuerys = !showMultiQuerys;
            }
          "
        >
          高级筛选
        </button> -->
        <button class="common-bg-button" @click="toEdit()">编辑</button>
        <button class="common-bg-button" @click="search()">查看</button>
        <button class="common-bg-button" @click="toLog()">更新记录</button>
        <button class="common-bg-button" @click="toHistoryViewing()">历史查看</button>
      </div>
      <!-- 高级筛选 -->
      <!-- <div class="multi-query-div el-fade-in-linear" v-if="showMultiQuerys">
        <div class="margin-bottom-16">
          <el-row :gutter="20">
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">关键字搜索</p>
              <el-input
                clearable
                v-model="queryInfo.searchKey"
                size="small"
                placeholder="请输入优惠券名称/优惠券编号/优惠券兑换流水号/兑换积分/积分流水号"
              ></el-input>
            </el-col>
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">优惠券品类</p>
              <el-select v-model="queryInfo.couponType"  size="small" clearable class="full-width" placeholder="请选择优惠券品类">
                <el-option v-for="a in couponTypeList" :key="a.code" :label="a.title" :value="a.code">
                </el-option>
            </el-select>
            </el-col>
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">卡券归属</p>
              <el-select v-model="queryInfo.couponBelong"  size="small" clearable class="full-width" placeholder="请选择卡券归属">
                <el-option v-for="a in couponOwnerList" :key="a.code" :label="a.title" :value="a.code">
                </el-option>
            </el-select>
            </el-col>
          </el-row>

          <el-row :gutter="20" class="margin-top-10">
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">发放状态</p>
              <el-select v-model="queryInfo.exchangeStatus"  size="small" clearable class="full-width" placeholder="请选择发放状态">
                <el-option v-for="a in exchangeStatusList" :key="a.code" :label="a.title" :value="a.code">
                </el-option>
            </el-select>
            </el-col>
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">兑换时间</p>
              <div class="flex-r">
                <el-date-picker
                  v-model="queryInfo.exchangeFrom"
                  type="datetime"
                  size="small"
                  prefix-icon="el-icon-date"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期时间"
                  class="flex-1"
                >
                </el-date-picker>
                <span class="time-query-line">-</span>
                <el-date-picker
                  v-model="queryInfo.exchangeTo"
                  type="datetime"
                  size="small"
                  prefix-icon="el-icon-date"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期时间"
                  class="flex-1"
                >
                </el-date-picker>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="query-flex-btns-div margin-bottom-16">
          <button class="common-bg-button" @click="getListData(pagination,true)">搜 索</button>
          <button class="common-bg-button" @click="resetQuery()">重 置</button>
        </div>
      </div> -->
      <!-- 表格 -->
      <div class="list-table">
        <ZD-table
          :tableColumns="pageConfig.listColumns"
          :operates="operates"
          :tableData="tableData"
          :tableConfig="pageConfig.tableConfig"
          :selections="selections"
          v-on:updateSelections="
            (sels) => {
              selections = sels;
            }
          "
        ></ZD-table>
      </div>
      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination
          :pagination="pagination"
          v-on:pageUpdate="getListData"
        ></ZD-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from "./page-config";
export default {
  data() {
    return {
      pageConfig: pageConfig, // 页面配置
      tableData: [], // 表格数据
      selections: [], // 表格选项
      pagination: pageConfig.pagination,
      queryInfo: {}, //初始化数据
      paidTime: [],
      showMultiQuerys: false,
      operates: {
        width: 220,
        fixed: "right",
        list: [],
      }, // 列操作按钮
      showSignUserValidDialog: false,
      userValidFormInfo: {},
      userValidFormRules: {},
      showRtOrderDialog: false,
      rtOrderFormInfo: {},
      rtOrderFormRules: {},
      couponTypeList:[
        // 01充电，02洗车，03代驾，04租车
        {code:'01',title:'充电'},
        {code:'02',title:'洗车'},
        {code:'03',title:'代驾'},
        {code:'04',title:'租车'},
      ],
      couponOwnerList:[
        // 01支付宝,02挚达
        {code:'01',title:'支付宝'},
        {code:'02',title:'挚达'},
      ],
      exchangeStatusList:[
        // 01成功,02失败
        {code:'01',title:'成功'},
        {code:'02',title:'失败'},
      ],
    };
  },
  methods: {
    search(){
      if (this.checkSelectOne(this.selections)) {
        let obj = {
          obj: this.selections[0],
        };
        localStorage.setItem('advDetail',JSON.stringify(obj.obj))
        this.$router.push({
          name: "advDetail",
          params: {
            search:'1'
          },
        });
      }
    },
    toEdit(){
      localStorage.removeItem('advDetail')
      if (this.checkSelectOne(this.selections)) {
        let obj = {
          obj: this.selections[0],
        };
        localStorage.setItem('advDetail',JSON.stringify(obj.obj))
        this.$router.push({
          name: "advDetail",
          params: obj,
        });
      }
    },
    toLog(){
      localStorage.removeItem('advUpdateLog')
      if (this.checkSelectOne(this.selections)) {
        let obj = {
          obj: this.selections[0],
        };
        localStorage.setItem('advUpdateLog',JSON.stringify(obj.obj))
        this.$router.push({
          name: "advUpdateLog",
          params: obj,
        });
      }
    },
    toHistoryViewing(){
      localStorage.removeItem('historyViewing')
      if (this.checkSelectOne(this.selections)) {
        let obj = {
          obj: this.selections[0],
        };
        localStorage.setItem('historyViewing',JSON.stringify(obj.obj))
        this.$router.push({
          name: "historyViewing",
          params: obj,
        });
      }
    },
    //获取数据
    init() {
      this.getListData(this.pagination, true);
    },
    // 获取表格数据
    getListData(pagination, reload = false) {
      let _ = this;
      _.$U.showLoading(_);
      _.queryInfo.pageNum = pagination.current - 1;
      if (reload) {
        _.pagination.current = 1;
        _.queryInfo.pageNum = 0;
      }
      _.queryInfo.pageSize = pagination.pageSize;
      _.queryInfo.corpNo = _.$store.state.corpNo;
      _.$H
        .get(_, _.$A.coupon.advertisement, _.queryInfo)
        .then((res) => {
          _.tableData = res.data.data.content || [];
          _.pagination.total = res.data.data.totalElements || 0;
          _.$U.hideLoading(_);
        });
    },
    checkSelectOne(selections) {
      if (selections.length < 1) {
        this.$U.error("请选择需要操作的对象");
        return false;
      }
      if (selections.length > 1) {
        this.$U.error("只能选择一个操作的对象");
        return false;
      }
      return true;
    },
    //选择时间
    pickdate(time) {
      console.log(time);
      let _ = this;
      // 拆分时间区间
      _.queryInfo.fromTransactionSucceedTime = time ? time[0] : "";
      _.queryInfo.toTransactionSucceedTime = time ? time[1] : "";
    },
    //重置
    reset() {
      delete this.queryInfo.walletListNo;
      delete this.queryInfo.mobile;
      delete this.queryInfo.packagName;
      delete this.queryInfo.fromTransactionSucceedTime;
      delete this.queryInfo.toTransactionSucceedTime;
      this.paidTime = [];
      this.getListData(this.pagination, true);
    },
    toShowUserValidFun() {
      this.showSignUserValidDialog = true;
    },
    submitUserValidForm() {},
    // 退款编辑
    toShowRtOrderEditFun() {
      this.showRtOrderDialog = true;
    },
    submitRtOrderForm() {},
    // 导出
    toExportList() {
      let _ = this;
      _.$U.showLoading(_);
      _.$H.post(_, _.$A.activityOrder.couponExport, _.queryInfo).then((res) => {
        _.$U.saveExcelFile(res.data.data);
        // var downUrl = 'http://192.168.8.174:7997'+res.data.data.filePath;
        var downUrl = 'http://ocharge.shzhida.com:6777'+res.data.data.filePath;
        window.open(downUrl, "_blank");
        _.$U.hideLoading(_);
      });
    },
    resetQuery(){
      this.queryInfo = {
        searchKey:undefined,
        couponType:undefined,
        exchangeStatus:undefined,
        exchangeFrom:undefined,
        exchangeTo:undefined,
      };
      this.getListData(this.pagination,true)
    },
  },
  mounted() {
    this.init();
  },
};
</script>
